const LinkListSchema = () => ({
  title: 'AgSUS Link List',
  fieldsets: [
    {
      id: 'default',
      title: 'Seção',
      fields: ['eyebrow', 'title', 'variant'],
    },
    { id: 'items', title: 'Links', fields: ['items'] },
  ],
  properties: {
    eyebrow: {
      title: 'Etiqueta',
      description: 'Texto curto em caixa alta, acima do título.',
    },
    title: { title: 'Título' },
    variant: {
      title: 'Variação visual',
      choices: [
        ['default', 'Padrão'],
        ['normatives', 'Normativas'],
      ],
      default: 'default',
    },
    items: {
      title: 'Links',
      widget: 'object_list',
      schema: {
        title: 'Link',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: ['label', 'href', 'meta'],
          },
        ],
        properties: {
          label: { title: 'Texto' },
          href: { title: 'Endereço' },
          meta: { title: 'Meta (data, tipo)' },
        },
        required: ['label'],
      },
    },
  },
  required: [],
});
export default LinkListSchema;
